import { isValidObject } from '../../Validity';

export const ourResultFromGoals = (goals: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[]) => {
    const ourGoals = ourPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    const opponentGoals = opponentPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    if (ourGoals > opponentGoals) {
        return 'Win';
    } if (opponentGoals > ourGoals) {
        return 'Loss';
    } if (opponentGoals === ourGoals) {
        return 'Tied';
    }
    return '-';
};

export const ourShortenedResultFromGoals = (goals: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[]) => {
    const ourGoals = ourPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    const opponentGoals = opponentPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    if (ourGoals > opponentGoals) {
        return 'W';
    } if (opponentGoals > ourGoals) {
        return 'L';
    } if (opponentGoals === ourGoals) {
        return 'T';
    }
    return '-';
};

export const ourTriesFromTries = (tries: any[]) => {
    let total = 0;
    if (isValidObject(tries)) {
        tries.forEach((rugbyTry: any) => {
            total += rugbyTry.team === 'our' ? 1 : 0;
        });
    }
    return total;
};

export const ourConversionsFromConversions = (conversions: any[]) => {
    let total = 0;
    if (isValidObject(conversions)) {
        conversions.forEach((conversion: any) => {
            total += conversion.team === 'our' ? 1 : 0;
        });
    }
    return total;
};

export const ourPenaltyKicksFromPenaltyKicksAndKickingGameStats = (penaltyKicks: any[], kickingGameStats: any) => {
    if (isValidObject(kickingGameStats) && isValidObject(kickingGameStats.penaltyKicks) && kickingGameStats.penaltyKicks !== 0) {
        return kickingGameStats.penaltyKicks;
    }
    let total = 0;
    if (isValidObject(penaltyKicks)) {
        penaltyKicks.forEach((penaltyKick: any) => {
            total += penaltyKick.team === 'our' ? 1 : 0;
        });
    }
    return total;
};

export const ourPenaltyGoalsFromPenaltyKicks = (penaltyKicks: any[]) => {
    let total = 0;
    if (isValidObject(penaltyKicks)) {
        penaltyKicks.forEach((penaltyKick: any) => {
            total += penaltyKick.team === 'our' && penaltyKick.convertedToGoal ? 1 : 0;
        });
    }
    return total;
};

export const ourDropGoalsFromDropGoals = (dropGoals: any[]) => {
    let total = 0;
    if (isValidObject(dropGoals)) {
        dropGoals.forEach((dropGoal: any) => {
            total += dropGoal.team === 'our' ? 1 : 0;
        });
    }
    return total;
};

export const ourTriesPointsFromTries = (tries: any[]) => {
    return 5 * ourTriesFromTries(tries);
};

export const ourConversionsPointsFromConversions = (conversions: any[]) => {
    return 2 * ourConversionsFromConversions(conversions);
};

export const ourPenaltyGoalsPointsFromPenaltyKicks = (penaltyKicks: any[]) => {
    return 3 * ourPenaltyGoalsFromPenaltyKicks(penaltyKicks);
};

export const ourDropGoalsPointsFromDropGoals = (dropGoals: any[]) => {
    return 3 * ourDropGoalsFromDropGoals(dropGoals);
};

export const ourPointsFromStats = (tries: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[]) => {
    let total = 0;
    total += ourTriesPointsFromTries(tries);
    total += ourConversionsPointsFromConversions(conversions);
    total += ourPenaltyGoalsPointsFromPenaltyKicks(penaltyKicks);
    total += ourDropGoalsPointsFromDropGoals(dropGoals);
    return total;
};

export const ourFoulsFromFouls = (fouls: any[]) => {
    let total = 0;
    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            total += foul.team === 'our' ? 1 : 0;
        });
    }
    return total;
};

export const ourYellowCardsFromFouls = (fouls: any[]) => {
    let total = 0;
    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            total += foul.team === 'our' && foul.yellowCard ? 1 : 0;
        });
    }
    return total;
};

export const ourRedCardsFromFouls = (fouls: any[]) => {
    let total = 0;
    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            total += foul.team === 'our' && foul.redCard ? 1 : 0;
        });
    }
    return total;
};

export const ourPassesFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.passes)) {
        return offensiveGameStats.passes;
    }
    return 0;
};

export const ourOffloadsFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.offloads)) {
        return offensiveGameStats.offloads;
    }
    return 0;
};

export const ourCarriesFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.carries)) {
        return offensiveGameStats.carries;
    }
    return 0;
};

export const ourMetersCarriedFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.metersCarried)) {
        return offensiveGameStats.metersCarried;
    }
    return 0;
};

export const ourDefendersBeatenFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.defendersBeaten)) {
        return offensiveGameStats.defendersBeaten;
    }
    return 0;
};

export const ourTurnoversConcededFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.turnoversConceded)) {
        return offensiveGameStats.turnoversConceded;
    }
    return 0;
};

export const ourCleanBreaksFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.cleanBreaks)) {
        return offensiveGameStats.cleanBreaks;
    }
    return 0;
};

export const ourPlusAndMinusFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.plusAndMinus)) {
        return offensiveGameStats.plusAndMinus;
    }
    return 0;
};

export const ourKickingInPlayFromKickingGameStats = (kickingGameStats: any) => {
    if (isValidObject(kickingGameStats) && isValidObject(kickingGameStats.kickingInPlay)) {
        return kickingGameStats.kickingInPlay;
    }
    return 0;
};

export const ourMissedTacklesFromDefensiveGameStats = (defensiveGameStats: any) => {
    if (isValidObject(defensiveGameStats) && isValidObject(defensiveGameStats.missedTackles)) {
        return defensiveGameStats.missedTackles;
    }
    return 0;
};

export const ourTacklesFromDefensiveGameStats = (defensiveGameStats: any) => {
    if (isValidObject(defensiveGameStats) && isValidObject(defensiveGameStats.tackles)) {
        return defensiveGameStats.tackles;
    }
    return 0;
};

export const ourTurnoversWonFromDefensiveGameStats = (defensiveGameStats: any) => {
    if (isValidObject(defensiveGameStats) && isValidObject(defensiveGameStats.turnoversWon)) {
        return defensiveGameStats.turnoversWon;
    }
    return 0;
};

export const ourLineoutsWonFromSetPlaysGameStats = (setPlaysGameStats: any) => {
    if (isValidObject(setPlaysGameStats) && isValidObject(setPlaysGameStats.lineoutsWon)) {
        return setPlaysGameStats.lineoutsWon;
    }
    return 0;
};

export const ourLineoutsLostFromSetPlaysGameStats = (setPlaysGameStats: any) => {
    if (isValidObject(setPlaysGameStats) && isValidObject(setPlaysGameStats.lineoutsLost)) {
        return setPlaysGameStats.lineoutsLost;
    }
    return 0;
};

export const ourScrumsWonFromSetPlaysGameStats = (setPlaysGameStats: any) => {
    if (isValidObject(setPlaysGameStats) && isValidObject(setPlaysGameStats.scrumssWon)) {
        return setPlaysGameStats.scrumsWon;
    }
    return 0;
};

export const ourScrumsLostFromSetPlaysGameStats = (setPlaysGameStats: any) => {
    if (isValidObject(setPlaysGameStats) && isValidObject(setPlaysGameStats.scrumsLost)) {
        return setPlaysGameStats.scrumsLost;
    }
    return 0;
};

// ---------------------------------------------------------------------------------------------------------
// Get opponent stats
// ---------------------------------------------------------------------------------------------------------

export const opponentResultFromGoals = (goals: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[]) => {
    const ourGoals = ourPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    const opponentGoals = opponentPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    if (ourGoals < opponentGoals) {
        return 'Win';
    } if (opponentGoals < ourGoals) {
        return 'Loss';
    } if (opponentGoals === ourGoals) {
        return 'Tied';
    }
    return '-';
};

export const opponentShortenedResultFromGoals = (goals: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[]) => {
    const ourGoals = ourPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    const opponentGoals = opponentPointsFromStats(goals, conversions, penaltyKicks, dropGoals);
    if (ourGoals < opponentGoals) {
        return 'W';
    } if (opponentGoals < ourGoals) {
        return 'L';
    } if (opponentGoals === ourGoals) {
        return 'T';
    }
    return '-';
};

export const opponentTriesFromTries = (tries: any[]) => {
    let total = 0;
    if (isValidObject(tries)) {
        tries.forEach((gameTry: any) => {
            total += gameTry.team === 'opponent' ? 1 : 0;
        });
    }
    return total;
};

export const opponentConversionsFromConversions = (conversions: any[]) => {
    let total = 0;
    if (isValidObject(conversions)) {
        conversions.forEach((conversion: any) => {
            total += conversion.team === 'opponent' ? 1 : 0;
        });
    }
    return total;
};

export const opponentPenaltyGoalsFromPenaltyKicks = (penaltyKicks: any[]) => {
    let total = 0;
    if (isValidObject(penaltyKicks)) {
        penaltyKicks.forEach((penaltyKick: any) => {
            total += penaltyKick.team === 'opponent' && penaltyKick.convertedToGoal ? 1 : 0;
        });
    }
    return total;
};

export const opponentPenaltyKicksFromPenaltyKicksAndKickingGameStats = (penaltyKicks: any[], kickingGameStats: any) => {
    if (isValidObject(kickingGameStats) && isValidObject(kickingGameStats.opponentPenaltyKicks) && kickingGameStats.opponentPenaltyKicks !== 0) {
        return kickingGameStats.opponentPenaltyKicks;
    }
    let total = 0;
    if (isValidObject(penaltyKicks)) {
        penaltyKicks.forEach((penaltyKick: any) => {
            total += penaltyKick.team === 'opponent' ? 1 : 0;
        });
    }
    return total;
};

export const opponentDropGoalsFromDropGoals = (dropGoals: any[]) => {
    let total = 0;
    if (isValidObject(dropGoals)) {
        dropGoals.forEach((dropGoal: any) => {
            total += dropGoal.team === 'opponent' ? 1 : 0;
        });
    }
    return total;
};

export const opponentTriesPointsFromTries = (tries: any[]) => {
    return 5 * opponentTriesFromTries(tries);
};

export const opponentConversionsPointsFromConversions = (conversions: any[]) => {
    return 2 * opponentConversionsFromConversions(conversions);
};

export const opponentPenaltyGoalsPointsFromPenaltyKicks = (penaltyKicks: any[]) => {
    return 3 * opponentPenaltyGoalsFromPenaltyKicks(penaltyKicks);
};

export const opponentDropGoalsPointsFromDropGoals = (dropGoals: any[]) => {
    return 3 * opponentDropGoalsFromDropGoals(dropGoals);
};

export const opponentPointsFromStats = (tries: any[], conversions: any[], penaltyKicks: any[], dropGoals: any[]) => {
    let total = 0;
    total += opponentTriesPointsFromTries(tries);
    total += opponentConversionsPointsFromConversions(conversions);
    total += opponentPenaltyGoalsPointsFromPenaltyKicks(penaltyKicks);
    total += opponentDropGoalsPointsFromDropGoals(dropGoals);
    return total;
};

export const opponentFoulsFromFouls = (fouls: any[]) => {
    let total = 0;
    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            total += foul.team === 'opponent' ? 1 : 0;
        });
    }
    return total;
};

export const opponentYellowCardsFromFouls = (fouls: any[]) => {
    let total = 0;
    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            total += foul.team === 'opponent' && foul.yellowCard ? 1 : 0;
        });
    }
    return total;
};

export const opponentRedCardsFromFouls = (fouls: any[]) => {
    let total = 0;
    if (isValidObject(fouls)) {
        fouls.forEach((foul: any) => {
            total += foul.team === 'opponent' && foul.redCard ? 1 : 0;
        });
    }
    return total;
};

export const opponentPassesFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.opponentPasses)) {
        return offensiveGameStats.opponentPasses;
    }
    return 0;
};

export const opponentOffloadsFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.opponentOffloads)) {
        return offensiveGameStats.opponentOffloads;
    }
    return 0;
};

export const opponentCarriesFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.opponentCarries)) {
        return offensiveGameStats.opponentCarries;
    }
    return 0;
};

export const opponentMetersCarriedFromOffensiveGameStats = (offensiveGameStats: any) => {
    if (isValidObject(offensiveGameStats) && isValidObject(offensiveGameStats.opponentMetersCarried)) {
        return offensiveGameStats.opponentMetersCarried;
    }
    return 0;
};

export const opponentTacklesFromDefensiveGameStats = (defensiveGameStats: any) => {
    if (isValidObject(defensiveGameStats) && isValidObject(defensiveGameStats.opponentTackles)) {
        return defensiveGameStats.opponentTackles;
    }
    return 0;
};

// ---------------------------------------------------------------------------------------------------------
// Get other stats
// ---------------------------------------------------------------------------------------------------------

export const lineoutsWonPercentageFromLineouts = (lineoutsWon: number, lineoutsLost: number) => {
    return (lineoutsWon / (lineoutsWon + lineoutsLost)).toFixed(2);
};

export const scrumsWonPercentageFromScrums = (scrumsWon: number, scrumsLost: number) => {
    return (scrumsWon / (scrumsWon + scrumsLost)).toFixed(2);
};
